import client from "./client";

const getAllByCurrentUser = () => {
  return client.get("/test-schedule-info/current-user").then((res) => {
    if (res.data?.success && Array.isArray(res.data?.result))
      return {
        data: res.data?.result.map((item) => ({
          id: item._id,
          testDate: item.testDate,
        })),
      };
    throw new Error("Malformed data!");
  });
};

const scheduleServices = {
  getAllByCurrentUser,
};

export default scheduleServices;
